<template>
  <div class="scheduler-props">
    <div class="d-flex mb-5 type-buttons">
      <div class="py-3 mr-3"
           :class="type=='headers' ? 'btn-custom btn-sm px-9' : 'type-text px-3' "
           @click="changeType('headers')">{{ $t('scheduler.headers') }}</div>
      <div class="py-3 mr-3"
           :class="type=='parameters' ? 'btn-custom btn-sm px-9' : 'type-text px-3' "
           @click="changeType('parameters')">{{ $t('scheduler.parameters') }}</div>
    </div>

    <!-- headers::begin -->
    <div class="type-area"
         v-if="type=='headers'">
      <div v-for="(hdr,index) in headerList"
           :key="`${index}-hdr`"
           class="mb-5">
        <div class="row mb-3">
          <div class="col-5">
            <b-form-input :id="`${index}-hdrKey`"
                          v-model="hdr.key"
                          :placeholder="$t('scheduler.enterVariable')"></b-form-input>
          </div>
          <div class="col-5">
            <b-form-input :id="`${index}-hdrValue`"
                          v-model="hdr.value"
                          :placeholder="$t('scheduler.enterValue')"></b-form-input>
          </div>
          <div class="col-2">
            <b-dropdown variant="success"
                        class="btn-icon more-dropdown"
                        right>
              <template v-slot:button-content><i class="fas fa-cog p-0"></i></i>
              </template>
              <b-dropdown-item @click="addHeader()">{{$t('scheduler.addNewVariable')}}</b-dropdown-item>
              <b-dropdown-divider />
              <b-dropdown-item @click="removeHeader(index)"
                               class="text-danger">{{$t('global.delete')}}</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
    </div>
    <!-- headers::end -->

    <!-- parameters::begin -->
    <div class="type-area"
         v-if="type=='parameters'">
      <div v-for="(prm,index) in parameterList"
           :key="`${index}-prm`"
           class="mb-5">
        <div class="row mb-3">
          <div class="col-5">
            <b-form-input :id="`${index}-prmKey`"
                          v-model="prm.key"
                          :placeholder="$t('scheduler.enterVariable')"></b-form-input>
          </div>
          <div class="col-5">
            <b-form-input :id="`${index}-prmValue`"
                          v-model="prm.value"
                          :placeholder="$t('scheduler.enterValue')"></b-form-input>
          </div>
          <div class="col-2">
            <b-dropdown variant="success"
                        class="btn-icon more-dropdown"
                        right>
              <template v-slot:button-content><i class="fas fa-cog p-0"></i></i>
              </template>
              <b-dropdown-item @click="addParameter()">{{$t('scheduler.addNewVariable')}}</b-dropdown-item>
              <b-dropdown-divider />
              <b-dropdown-item @click="removeParameter(index)"
                               class="text-danger">{{$t('global.delete')}}</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
    </div>
    <!-- parameters::end -->

    <div class="d-flex">
      <span class="btn btn-danger btn-sm d-block px-9 py-3 rounded mr-3"
            @click="close">{{ $t('global.cancel') }}</span>
      <span class="btn btn-primary btn-sm d-block px-9 py-3 rounded"
            @click="confirm">{{ $t('verification.confirm') }}</span>
    </div>
  </div>
</template>

<script> 
export default {
  name: 'SchedulerProps',
  props: {
    selectedType: String,
    headerListProp: String | Object,
    parameterListProp: String | Object,
  },
  data() {
    return {
      type: '',
      headerList: [{ key: '', value: '' }],
      parameterList: [{ key: '', value: '' }],
    }
  },
  created() {
    this.type = this.selectedType
    this.headerList = this.headerListProp
    this.parameterList = this.parameterListProp
  },
  methods: {
    changeType(type) {
      this.type = type
    },
    addHeader() {
      this.headerList.push({ key: '', value: '' })
    },
    removeHeader(index) {
      this.headerList.splice(index, 1)
      if (this.headerList.length == 0) this.addHeader()
    },
    addParameter() {
      this.parameterList.push({ key: '', value: '' })
    },
    removeParameter(index) {
      this.parameterList.splice(index, 1)
      if (this.parameterList.length == 0) this.addHeader()
    },
    close() {
      this.$emit('closeSecondModal', false)
    },
    confirm() {
      this.$emit('changeHeaderList', this.headerList)
      this.$emit('changeParameterList', this.parameterList)
      this.$emit('closeSecondModal', false)
    },
  }, 
  watch: {
    selectedType(newVal) {
      this.type = newVal
    },
  },
}
</script> 


<style lang="scss" scoped>
.scheduler-props {
  .type-buttons {
    border-bottom: 1px solid #eeeff3;
    padding-bottom: 15px;
    .btn-custom {
      background: #eee5ff;
      border-radius: 4px !important;
      color: #00baf2;
      &:hover,
      &:focus {
        background: #eae1fb;
      }
    }
    .type-text {
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 19px;
      color: #6c7293;
      cursor: pointer;
      border: none;
    }
  }
  .type-area {
    margin-bottom: 20px;
  }
}
</style>